import { FC } from 'react';

interface IBodyWrapper {
	label?: JSX.Element;
	headerElement?: JSX.Element;
	bodyElement?: JSX.Element;
	footerElement?: JSX.Element;
}
export const BodyWrapper: FC<IBodyWrapper> = ({
	label,
	headerElement,
	footerElement,
	bodyElement,
}) => {
	return (
		<div className="ppl-screen-body">
			{label}
			<div className="ppl-screen-body__body">
				{headerElement}
				{bodyElement}
				{footerElement}
			</div>
		</div>
	);
};
